import s from './style.module.scss';
import noAuthImg from '@/assets/images/res/no-auth.webp';
const NoAuth = (props) => {
    return (
        <>
            <div className={s['no-auth']}>
                <div className={s['no-auth-img']}>
                    <img src={noAuthImg} alt="no-auth" />
                </div>
                <div className={s['no-auth-text']}>{props?.text}</div>
            </div>
        </>
    );
};
export default NoAuth;
